var render, staticRenderFns
import script from "./GraficoInstituicoes.vue?vue&type=script&lang=js&"
export * from "./GraficoInstituicoes.vue?vue&type=script&lang=js&"
import style0 from "./GraficoInstituicoes.vue?vue&type=style&index=0&id=4868d490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868d490",
  null
  
)

export default component.exports